import styled from 'styled-components';

export const PdfContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  flex: 1;
`;
